var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagNorfolkIsland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 1.58763C20.853 0.5705 18.4932 0 16 0C13.5068 0 11.147 0.5705 9.04347 1.58763L7.65216 16L9.04347 30.4124C11.147 31.4295 13.5068 32 16 32C18.4932 32 20.853 31.4295 22.9565 30.4124L24.3478 16L22.9565 1.58763Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 1.58813C3.69156 4.17601 0 9.65657 0 15.9999C0 22.3433 3.69156 27.8239 9.0435 30.4118V1.58813Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9561 1.58813V30.4118C28.308 27.8239 31.9996 22.3433 31.9996 15.9999C31.9996 9.65664 28.308 4.17601 22.9561 1.58813Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1739 20.8695L16 7.6521L11.826 20.8695H14.9565V24.3477H17.0435V20.8695H20.1739Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagNorfolkIsland);
export default __webpack_public_path__ + "static/media/flag_norfolk_island.9df09cac6fff21a8afa18cfacc0b02df.svg";
export { ForwardRef as ReactComponent };